import { HttpParams } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { LazyLoadEvent } from 'primeng/primeng';

import { ExecutingUnit } from '../entities/executingUnit';
import { BaseCrudService } from '../../shared/_utils/services/base-crud-service';
import { QueryOperator } from '../../shared/_utils/services/query-operator.enum'; 
import { ResponsePageable } from '../../shared/_utils/services/responsePageable';
import { User } from '../model/user';
import { Observable } from 'rxjs/Observable';
import { tap, catchError, switchAll } from 'rxjs/operators';


interface ExtraSearchFields {
  user? :User;
}

@Injectable()
export class UsersService extends BaseCrudService<User> {

  public uri = '/api/userSystem/';
  ADMINISTRADOR_LIT = "01";
  constructor(injector: Injector) {
    super(injector);
   //console.log('Instance UserService');
  }
 
  buildSentence(entity?: User, event?: LazyLoadEvent, extraSearchFields?: ExtraSearchFields ): HttpParams { 
    if (entity || extraSearchFields) {
      let query = '';
      query = query.concat(
        entity && entity.userName ?
          `userName${QueryOperator.Contain}${entity.userName}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity && entity.firstLastName ?
          `firstLastName${QueryOperator.Contain}${entity.firstLastName}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity && entity.secondLastName ?
          `secondLastName${QueryOperator.Contain}${entity.secondLastName}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity && entity.name ?
          `name${QueryOperator.Contain}${entity.name}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity && entity.executingUnit ?
          `executingUnit.id${QueryOperator.Equal}${entity.executingUnit.id}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity && entity.rol ?
          `rol.id${QueryOperator.Equal}${entity.rol.id}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity && entity.userNoAdmin?
          `rol.code${QueryOperator.NotEquals}${this.ADMINISTRADOR_LIT}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity && entity.fullName ?
          `fullName${QueryOperator.Contain}${entity.fullName}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      /*let query = entity.executingUnit ? 'executingUnit'
        + QueryOperator.Contain + entity.executingUnit
        + QueryOperator.Split : QueryOperator.Empty;  
      if (entity.executingUnit && entity.executingUnit.id) {
        query = query.concat(
          `executingUnit.id${QueryOperator.Equal}${entity.executingUnit.id}${QueryOperator.Split}`
        );
      }  
      */
    //console.log(query);
      this.httpParams = this.httpParams.set(QueryOperator.QueryParam, query);
    }  
    if (event) {
      const page = ((event.first + event.rows) / event.rows - 1).toString();
      const size = event.rows.toString();
      this.httpParams = this.httpParams.set(QueryOperator.PageParam, page);
      this.httpParams = this.httpParams.set(QueryOperator.SizeParam, size);
    }
    return this.httpParams;
  }
  
  amountUserByRole(executingUnitId : number ): Observable<any> {
   //console.log('amountUserByRole');
    const url = `${this.rutaServidor}${this.uri}amountUserByRole`; 
   //console.log("url : " +  url);
    //this.spinnerService.showAll();
    return this.httpClient.get<any>(url + "?eu_id=" + executingUnitId);
  }

  
  copyUserPermissions(copiedUser: number, lstUsers : number[]){
    const url = `${this.rutaServidor}${this.uri}copyUserPermissions/`+copiedUser; 
    //console.log("url : " +  url);
     //this.spinnerService.showAll();
     return this.httpClient.post<any>(url, lstUsers);

  }

/**   
 *  usersByExecutingUnit(executingUnitId : number ): Observable<User> {
   //console.log('usersByExecutingUnit');
    const url = `${this.rutaServidor}${this.uri}usersByExecutingUnit`; 
   //console.log("url : " +  url);
    //this.spinnerService.showAll();
    return this.httpClient.get<User>(url + "?eu_id=" + executingUnitId);
  }
*/

}



// WEBPACK FOOTER //
// ./src/app/core/services/user.service.ts